
import React from "react";
import {
    Button,
    FlexColumn,
    SeparatorLine,
    SushiModal,
} from "../../Common/styles.common";
import { Loader } from "../../Common/Loader";
import BackButton from "../../Button/BackButton";
import { useNavigate } from "react-router-dom";
import styles from "../../Login/Login.module.scss";
import OtpInput from "react-otp-input";
import { errorDisp } from "../../Login/styles.login";
import Cross from "sushiweb/Icons/all/Cross";
import redCross from "../PodValidationImages/Cross.svg";
import greenCheck from "../PodValidationImages/Check.svg";

// ─── Inline styled zones ────────────────────────────────────────────────────

const pageStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    background: "#f5f5f5",
};

const headerStyle = {
    background: "#ffffff",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexShrink: 0,
};

const bodyStyle = {
    flex: 1,
    overflowY: "auto",
    padding: "24px",
    display: "flex",
    gap: 24,
    alignItems: "flex-start",
};

const cardStyle = {
    background: "#ffffff",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    flex: 1,
};

const footerStyle = {
    background: "#ffffff",
    boxShadow: "0 -1px 4px rgba(0,0,0,0.08)",
    padding: "16px 24px",
    display: "flex",
    justifyContent: "flex-end",
    flexShrink: 0,
};

const footerBtnStyle = {
    maxWidth: 320,
    width: "100%",
};

// ─── Component ───────────────────────────────────────────────────────────────

export default function DDPodFormV2Desktop({
    po,
    items,
    showLoader,
    tonnage,
    errorMsg,
    otpPage,
    otp,
    setOtp,
    showError,
    openConfirmation,
    imageArray,
    previewImage,
    fileTypeErr,
    errorText,
    showPopUp,
    podPopUp,
    doneMsg,
    navigateToOtpPage,
    makeValidateOtp,
    closeConfirmation,
    imageValidationPopUpCloseHandler,
    handleImageInputChange,
}) {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(`/ddPo/all`);
        window.location.reload();
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <div style={pageStyle}>
            {/* ── Header ── */}
            <div style={headerStyle}>
                <span style={{ cursor: "pointer" }} onClick={handleBackClick}>
                    <BackButton />
                </span>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="fs-18 fw-700">
                        {po.purchase_order_number}
                    </span>
                    <span className="fs-12 fw-400 text-gray-cool" style={{ marginTop: 2 }}>
                        {items?.length} product{items?.length > 1 ? "s" : ""}
                        {" "}•{" "}
                        {tonnage > 999
                            ? (tonnage / 1000).toFixed(2)
                            : typeof tonnage === "number"
                            ? tonnage.toFixed(2)
                            : tonnage}{" "}
                        {tonnage > 999 ? "tonne" : "kg"}
                    </span>
                </div>
            </div>

            {/* ── Body (two-column cards) ── */}
            <div style={bodyStyle}>
                {/* Left card */}
                <div style={cardStyle}>
                    {otpPage ? (
                        /* OTP entry */
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span className="fs-18 fw-700">Enter verification code</span>
                            <span className="fs-12 fw-400 text-gray-cool" style={{ marginTop: 4, marginBottom: 20 }}>
                                shared by customer during delivery
                            </span>
                            <OtpInput
                                inputType="number"
                                containerStyle={`${styles.otpInputField} mb-3`}
                                value={otp}
                                onChange={(val) => setOtp(val)}
                                numInputs={6}
                                renderSeperator={"-"}
                                renderInput={(a) => <input {...a} />}
                            />
                            {showError ? (
                                <errorDisp className="fs-12 text-red-700 mb-3">
                                    {errorText || "Wrong OTP Entered"}
                                </errorDisp>
                            ) : (
                                <div style={{ marginBottom: 12 }} />
                            )}
                        </div>
                    ) : (
                        /* Upload instructions */
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span className="fs-18 fw-700">Upload hyperpure delivery challan</span>
                            <span className="fs-12 fw-400 text-gray-cool" style={{ marginTop: 4 }}>
                                with signature and issue
                            </span>
                            <span className="fs-9 fw-400 text-gray-cool" style={{ marginTop: 4 }}>
                                (supported file types are .jpeg, .jpg, .png and .tiff)
                            </span>
                        </div>
                    )}
                </div>

                {/* Right card */}
                <div style={cardStyle}>
                    {otpPage ? (
                        /* Nothing extra needed on OTP page — confirmation is in a modal */
                        <div />
                    ) : (
                        /* Image upload grid */
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <SeparatorLine mt="0" mb="16px" />
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                                {imageArray.map((box, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: 140,
                                            height: 140,
                                            border: "1px dashed #d0d0d0",
                                            borderRadius: 8,
                                            overflow: "hidden",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fafafa",
                                        }}
                                    >
                                        {previewImage && previewImage[index] ? (
                                            <div style={{ width: "100%", height: "100%", position: "relative" }}>
                                                <img
                                                    className="image-preview-1"
                                                    src={previewImage[index]?.img_url}
                                                    alt={`Image-${index + 1}`}
                                                    id={`Image-icon-desktop-v2-${index}`}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                                <div
                                                    className="fs-10 fw-400 text-red-500"
                                                    style={{
                                                        position: "absolute",
                                                        bottom: 4,
                                                        left: 4,
                                                        background: "rgba(255,255,255,0.85)",
                                                        padding: "1px 4px",
                                                        borderRadius: 3,
                                                    }}
                                                >
                                                    {`Page ${previewImage[index]?.page_no}`}
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageInputChange(e, index + 1)}
                                                    style={{ display: "none" }}
                                                    id={`imageInput-desktop-v2-${index}`}
                                                />
                                                <label
                                                    htmlFor={`imageInput-desktop-v2-${index}`}
                                                    style={{ cursor: "pointer", marginBottom: 4 }}
                                                >
                                                    <img
                                                        className="icon"
                                                        src={"/logos/camera_add.svg"}
                                                        width="36px"
                                                        height="36px"
                                                        alt="Upload Image"
                                                        id={`Image-icon-desktop-v2-${index}`}
                                                    />
                                                </label>
                                                <span className="fs-10 fw-400 text-red-500">
                                                    {`Page ${index + 1}`}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Status messages */}
                            {errorMsg ? (
                                <errorDisp className="fs-12 text-red-700" style={{ marginTop: 12 }}>
                                    Please add delivery challan
                                </errorDisp>
                            ) : doneMsg ? (
                                <errorDisp className="d-flex" style={{ marginTop: 12 }}>
                                    <img src={greenCheck} className="mr-1" alt="done" />
                                    <span className="mt-1 fs-12 text-green-700">All pages uploaded</span>
                                </errorDisp>
                            ) : fileTypeErr ? (
                                <errorDisp className="fs-12 text-red-700" style={{ marginTop: 12 }}>
                                    Please upload images with correct file type
                                </errorDisp>
                            ) : (
                                <div style={{ marginBottom: 16 }} />
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* ── Footer ── */}
            <div style={footerStyle}>
                <div style={footerBtnStyle}>
                    {otpPage ? (
                        <Button
                            className="fs-13 text-white fw-600"
                            onClick={makeValidateOtp}
                        >
                            Mark delivered
                        </Button>
                    ) : (
                        <Button
                            className="fs-13 text-white fw-600"
                            onClick={navigateToOtpPage}
                        >
                            Verify with OTP
                        </Button>
                    )}
                </div>
            </div>

            {/* ── Confirmation modal ── */}
            <SushiModal visible={openConfirmation} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <img src="/logos/tick_logo.svg" height="80px" width="80px" alt="delivered" />
                    <span className="fs-22 fw-700 my-4">Order delivered</span>
                    <span
                        className="fs-14 fw-500 text-red-500"
                        style={{ cursor: "pointer" }}
                        onClick={closeConfirmation}
                    >
                        {" "}Okay
                    </span>
                </FlexColumn>
            </SushiModal>

            {/* ── Image-validation popup ── */}
            <SushiModal visible={showPopUp} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <div
                        className="align-self-end"
                        style={{ cursor: "pointer" }}
                        onClick={imageValidationPopUpCloseHandler}
                    >
                        <Cross />
                    </div>
                    <img src={podPopUp?.image_link} height="80px" width="80px" alt="popup" />
                    <span className="fs-22 fw-700 my-4">{podPopUp?.title}</span>
                    <span className="fs-12 mb-4">{podPopUp?.content}</span>
                    <div className="invalid-image-box">
                        <div className="d-flex justify-content-between">
                            {podPopUp?.negative_tags?.map((tag) => (
                                <span key={tag} className="d-flex justify-content-between fs-15">
                                    <img src={redCross} alt="invalid" />
                                    <span className="mt-1">{tag}</span>
                                </span>
                            ))}
                            {podPopUp?.positive_tags?.map((tag) => (
                                <span key={tag} className="d-flex justify-content-between fs-15">
                                    <img src={greenCheck} alt="valid" />
                                    <span className="mt-1">{tag}</span>
                                </span>
                            ))}
                        </div>
                    </div>
                    <span
                        className="fs-14 fw-500 text-red-500 mt-4"
                        style={{ cursor: "pointer" }}
                        onClick={imageValidationPopUpCloseHandler}
                    >
                        Retake photo
                    </span>
                </FlexColumn>
            </SushiModal>
        </div>
    );
}
